import { inject, Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'safeCurrency',
  standalone: true,
})
export class SafeCurrencyPipe implements PipeTransform {
  private readonly _currencyPipe = inject(CurrencyPipe);

  transform(value: string | number | null | undefined): string {
    if (!value && value !== 0) return '-';

    return this._currencyPipe.transform(value, 'USD', 'symbol', '1.2-2') ?? '-';
  }
}
